import sortBy from 'lodash.sortby'

const sortTasksByEndDate = (data) => sortBy(data, 'end_date')

export default sortTasksByEndDate
